import { Dictionary } from '@/composables/advert/advertManager'

export default {
  install: (app: any, options: Array<Array<string>>) => {
    const resolvedTransMap = new Map<string, string>()

    const findTrans = (key: string) => {
      return key.split('.').reduce((o: any, i: string) => {
        if (o) return o[i]
      }, options)
    }

    const pluralizeTrans = (key: string, count: number) => {
      const transParts = key.split('|')

      if (count in transParts) {
        return transParts[count]
      }

      if (transParts.length > 0) {
        return transParts[transParts.length - 1]
      }

      return undefined
    }

    const replaceParams = (trans: string, params: Dictionary<string>) => {
      let replacedTrans = trans

      for (const [key, value] of Object.entries(params)) {
        replacedTrans = replacedTrans.replace('{' + key + '}', value)
      }

      return replacedTrans
    }

    app.config.globalProperties.$translate = (key: string) => {
      if (typeof key === 'undefined') {
        return ''
      }

      if (resolvedTransMap.has(key)) {
        return resolvedTransMap.get(key)
      }
      const trans = findTrans(key)

      if (typeof trans === 'undefined') {
        resolvedTransMap.set(key, key)

        return key
      }
      resolvedTransMap.set(key, trans)

      return trans
    }

    app.config.globalProperties.$translateCount = (
      key: string,
      count: number,
      params: Dictionary<string> = {}
    ) => {
      if (typeof key === 'undefined') {
        return ''
      }

      const cacheKey = key + '_' + count
      if (resolvedTransMap.has(cacheKey)) {
        return resolvedTransMap.get(cacheKey)
      }

      const trans = findTrans(key)

      if (typeof trans === 'undefined') {
        resolvedTransMap.set(cacheKey, key)

        return key
      }

      const pluralizedTrans = pluralizeTrans(trans, count)

      if (typeof pluralizedTrans === 'undefined') {
        resolvedTransMap.set(cacheKey, key)

        return key
      }

      if (Object.keys(params).length > 0) {
        const replaced = replaceParams(pluralizedTrans, params)
        resolvedTransMap.set(cacheKey, replaced)

        return replaced
      }
      resolvedTransMap.set(cacheKey, pluralizedTrans)

      return pluralizedTrans
    }

    app.provide('i18n', options)
  },
}
